import React from "react";
import { Link } from "react-router-dom";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="service-container">
        <div className="section-title">
          <h2>Produtos</h2>
        </div>
        <h3 className="subtitle">Linha Estudantil</h3>
        <div className="box-row">
          {props.data
            ? props.data.LinhaEstudantil.map((d, i) => (
                <a href={d.link} key={`${d.name}-${i}`} className="box">
                  {" "}
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                  </div>
                  <div className="service-image">
                    <img src={d.img} alt="" />
                  </div>
                </a>
              ))
            : "loading"}
        </div>
        <h3 className="subtitle">Linha de Comércio e serviços </h3>
        <div className="box-row">
          {props.data
            ? props.data.LinhaDeComercio.map((d, i) => (
                <a href={d.link} key={`${d.name}-${i}`} className="box">
                  {" "}
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                  </div>
                  <img className="service-image" src={d.img} alt="" />
                </a>
              ))
            : "loading"}
        </div>
        <Link to="/products"><h3 className="more">Ver Mais</h3></Link>
      </div>
    </div>
  );
};